import {
  localize
} from 'vee-validate'

function loadLocale (code) {
  return import(`vee-validate/dist/locale/${code}.json`).then((locale) => {
    localize(code, locale)
  })
}

export default function ({ i18n, store }) {
  const locale = i18n.locale
  loadLocale(locale)

  i18n.onBeforeLanguageSwitch = (oldLocale, newLocale, isInitialSetup, contex) => {
    if (!isInitialSetup) {
      loadLocale(newLocale)
    }
  }
  i18n.onLanguageSwitched = (oldLocale, newLocale) => {
    store.dispatch('menu/fetchShopCategories')
    store.dispatch('menu/fetchBlogCategories')
  }
}
